import React, { useEffect, useState } from 'react'
import { Calendar as ReactCalendar } from 'react-big-calendar'
import { useDispatch, useSelector } from 'react-redux'

import AvailabilityCalendarTitle from './AvailabilityCalendarTitle'
import TimeSlotWrapper from '../../../../../components/pages/Register/CreateBanners/components/Step2/TimeSlotWrapper'
import WeekDaysHeader from '../../../../../components/pages/Register/CreateBanners/components/Step2/WeekDaysHeader'
import { Button } from '../../../../../components/UI'

import {
  selectAvailableEventsIsFetching,
  selectAvailableEventsNewCreated,
} from '../../../../../routing/fetchingfunction/user/user.reducer'
import {
  addNewAvailabilities,
  fetchAvailableEvents,
} from '../../../../../routing/fetchingfunction/user/user.action'

import { useAvailableCategories, useMainCategories } from '../../../../../hooks'

import { localizer } from '../../../../../constants'

const AvailabilityCategory = ({ advanceBooking, repeatWeekly, onAdvanceErrorChange }) => {
  const dispatch = useDispatch()

  const [category, setCategory] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isLoading = useSelector(selectAvailableEventsIsFetching)
  const newCreatedEvents = useSelector(selectAvailableEventsNewCreated)

  const mainCategories = useMainCategories()
  const { formattedClassBannerCategories, formattedBanners } = useAvailableCategories()

  const handleSubmit = () => {
    if (!advanceBooking) {
      return onAdvanceErrorChange('Please select a value')
    }

    setIsSubmitting(true)

    onAdvanceErrorChange(null)

    dispatch(
      addNewAvailabilities({
        availability_calendars: newCreatedEvents,
        calendar_settings: {
          repeat_weekly: repeatWeekly,
          advance_booking: advanceBooking,
        },
      })
    ).finally(() => {
      setIsSubmitting(false)
    })
  }

  useEffect(() => {
    dispatch(fetchAvailableEvents())
  }, [])

  return (
    <div className="mt-[20px] p-[32px] rounded-[10px] bg-[#FEEBDD]">
      <h4 className="text-base font-bold text-primary-100">Availability per Category</h4>

      <h5 className="mt-[8px] text-sm font-normal text-primary-100">
        Select time slots for when you’re available for a booking.
      </h5>

      <div className="relative text-primary-100">
        {isLoading ? (
          <div className="min-h-[600px] flex items-center justify-center">
            <div
              className="inline-block h-10 w-10 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] animate-spinInfinite"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : (
          <>
            <ReactCalendar
              className="metaverse-calendar"
              defaultView="week"
              startAccessor="start"
              endAccessor="end"
              localizer={localizer}
              defaultDate={new Date()}
              style={{ height: '600px', width: '100%' }}
              components={{
                toolbar: (props) => (
                  <AvailabilityCalendarTitle
                    {...props}
                    formattedPassedCategories={formattedBanners}
                    category={category}
                    onCategoryChange={setCategory}
                  />
                ),
                timeSlotWrapper: (props) => (
                  <TimeSlotWrapper
                    {...props}
                    mainCategories={mainCategories}
                    notUseLastCategory
                    category={category}
                  />
                ),
                header: WeekDaysHeader,
              }}
              timeslots={1}
              step={60}
            />

            <div className="flex items-start justify-between mt-[16px]">
              <p className="text-base font-medium">
                *You can’t work for more than 40 hours per week
              </p>

              <div className="flex gap-2">
                <Button
                  className="min-w-[200px] font-semibold text-base"
                  onClick={handleSubmit}
                  isLoading={isSubmitting}
                >
                  Save
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default AvailabilityCategory
